"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortValueDetails = exports.getValuesByCategoryFromState = exports.getCategoriesFromState = exports.getFirstValue = void 0;
const LabelValueSorting_1 = require("../LabelValueSorting");
const LabelType_1 = require("../shared/LabelType");
function getFirstValue(state, category) {
    var _a;
    const c = category !== null && category !== void 0 ? category : (_a = getCategoriesFromState(state)) === null || _a === void 0 ? void 0 : _a[0];
    if (!c) {
        return undefined;
    }
    const value = getValuesByCategoryFromState(c, state).at(0);
    return { category: c, value };
}
exports.getFirstValue = getFirstValue;
function getCategoriesFromState(state) {
    return (0, LabelValueSorting_1.sortCategories)(Object.keys(state));
}
exports.getCategoriesFromState = getCategoriesFromState;
function getValuesByCategoryFromState(category, state) {
    var _a;
    return sortValueDetails(category, Object.keys((_a = state[category]) !== null && _a !== void 0 ? _a : {}).map(name => ({ name })));
}
exports.getValuesByCategoryFromState = getValuesByCategoryFromState;
function sortValueDetails(category, details) {
    const localizedCategory = (0, LabelType_1.localizeCategory)(category);
    return [...details].sort((a, b) => {
        const valueA = typeof a === 'string' ? a : a.name;
        const valueB = typeof b === 'string' ? b : b.name;
        return (0, LabelValueSorting_1.sortLabelValues)({
            category,
            localizedCategory,
            value: valueA,
            localizedValue: (0, LabelType_1.localizeLabelValueName)(valueA),
        }, {
            category,
            localizedCategory,
            value: valueB,
            localizedValue: (0, LabelType_1.localizeLabelValueName)(valueB),
        });
    });
}
exports.sortValueDetails = sortValueDetails;
//# sourceMappingURL=LabelDialogStateHelpers.js.map